import { Component } from '@angular/core';

@Component({selector: 'app-offboarding-unavailable', template: `
  <section class="component-background" role="status">
    <h1>{{ 'OFFBOARD_REGISTRY' | translate }}</h1>
    <p>{{ 'OFFBOARD_LEGACY_UNAVAILABLE' | translate }}</p>
    <a routerLink="/dashboard/home">{{ 'NOTIFICATIONS' | translate }}</a>
  </section>`})
export class OffboardingUnavailableComponent {}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-unavailable.component.ts